import { useRef } from 'react'

import ImageMenuModalStyles from '../ImageMenuModal.module.scss'

import { useConfirmModal } from 'hooks/useConfirmModal'
import { useGenerateImages } from 'components/GenerateImageDrawer/hooks/useGenerateImages'

import { Modal } from 'almanac-ui/Modal'
import { AiConfirmModal } from 'components/ImagePickerModal/AIGeneration/AiConfirmModal'
import { GenerateImageModalContent } from 'components/GenerateImageModal/GenerateImageModal'
import { useImageMenuContext } from '../ImageMenuContext'
import { Actions } from '../ImageMenuModal'

export const AiGeneration = () => {
  const aiConfirmProvider = useConfirmModal(AiConfirmModal)
  const containerRef = useRef<HTMLDivElement>(null)
  const props = useGenerateImages({ containerRef })
  const { setProvider, toggleSelectedImage } = useImageMenuContext()

  const showConfirmModalIfNecessary = async () => {
    if (props.generationSets.length > 0) {
      const confirm = await aiConfirmProvider()

      if (confirm) {
        setProvider('')
      }

      return
    }

    setProvider('')
  }

  return (
    <>
      <Modal.Header
        className={ImageMenuModalStyles.header}
        actions={<Actions />}
        title="Generate an Image"
        onBack={showConfirmModalIfNecessary}
      />
      <GenerateImageModalContent
        showExamples={false}
        containerRef={containerRef}
        onConfirm={(image) => toggleSelectedImage({ ...image, provider: 'ai' })}
        {...props}
      />
    </>
  )
}
